import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore.js';

const sideConversationStoreConfig = {
  id: 'sideConversationStore',
  initialState: {
    selectedMailbox: null,
    to: null,
    cc: null,
    bcc: null,
    subject: null
  },
  methods: (set, get) => ({
    setTo: (to: any) => {
      set({ to });
    },
    setCc: (cc: any) => {
      set({ cc });
    },
    setBcc: (bcc: any) => {
      set({ bcc });
    },
    setSelectedMailbox: (mailbox: any) => {
      set({ selectedMailbox: mailbox });
    },
    setSubject: (subject: string) => {
      set({ subject });
    },
    resetSideConversationData: () => {
      set({
        selectedMailbox: null,
        to: null,
        cc: null,
        bcc: null,
        subject: null
      });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true,
    scope: 'global'
  }
};

const storeInstances = new Map();

// Function to create or get existing store instance
const createSideConversationActionStore = (componentId) => {
  if (storeInstances.has(componentId)) {
    return storeInstances.get(componentId);
  }

  const config = {
    ...sideConversationStoreConfig,
    id: `sideConversationAction_${componentId}`
  };

  const storeInstance = createStore(config);
  storeInstances.set(componentId, storeInstance);
  return storeInstance;
};

// Custom hook to return appropriate store based on props
export const useSideConversationActionStore = (props: {
  workId: string;
  module: string;
  conversationId: string;
}) => {
  const { workId, module, conversationId } = props;

  if (!workId || !module || !conversationId) {
    throw new Error('module and workId and conversationId are required');
  }

  // Create component id using ticket id and mode suffix
  const finalComponentId = `${module}_${workId}_${conversationId}_global_side_conversation`;

  // For regular components, create/get unique instance based on componentId
  if (finalComponentId) {
    return createSideConversationActionStore(finalComponentId);
  }

  return useSideConversationActionStore;
};
